import { render, staticRenderFns } from "./FileUploadLabel.vue?vue&type=template&id=5d6607bc&scoped=true&"
import script from "./FileUploadLabel.vue?vue&type=script&lang=ts&"
export * from "./FileUploadLabel.vue?vue&type=script&lang=ts&"
import style0 from "./FileUploadLabel.vue?vue&type=style&index=0&id=5d6607bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6607bc",
  null
  
)

export default component.exports